/**
 * Typings du SDK Tealium utag.js exposés sur window.
 * Documentation : https://docs.tealium.com/platforms/javascript/single-page-applications/
 */

export type TealiumData = Record<string, unknown>;

export interface TealiumUtag {
  view: (data?: TealiumData) => void;
  link: (data?: TealiumData) => void;
  track: (eventType: string, data?: TealiumData) => void;
  /** Cookie helpers exposed by utag */
  gdpr?: {
    setConsentValue?: (value: boolean) => void;
    getConsentState?: () => unknown;
  };
}

declare global {
  interface Window {
    /** Configuration consommée par utag.js avant son chargement */
    utag_cfg_ovrd?: {
      noview?: boolean;
      [key: string]: unknown;
    };
    /** Data layer initial (re-déclaré à chaque utag.view en SPA) */
    utag_data?: TealiumData;
    /** Instance SDK une fois utag.js téléchargé */
    utag?: TealiumUtag;
  }
}
